import React, { useEffect } from 'react';
import {connect, useSelector} from "react-redux";
import {getStateByPath} from "../../../redux/selectors";

// components
import {showLoader} from "../../../components/loader/loader";

// actions
import {
    ADD_STATE,
    REMOVE_STATE,
    setApp,
    setCategory,
    setUserIsAdmin
} from "../../../redux/actions/generics/IndexedActions";
import AybCategoryList from "../../ayb/category/_list";

// Proyecto a futuro: Cambiar el nombre de la clase a AybCategory
// Ayb -> ccs (Centro de consumo y servicio)
const XpaCategory = props => {
    const path = 'ccs/category';
    const componentState = useSelector(state => getStateByPath(state, path));
    const { loading } = componentState?.data || false;

    useEffect(() => {
        props.ADD_STATE(path);

        return () => {
            props.REMOVE_STATE(path);
        }
    }, []);

    useEffect(() => {
        props.setCategory('XPA');

        if (props.categoryCode !== undefined && props.categoryCode !== null) {
            props.setCategory(path, props.categoryCode);
        }

        if (props.app !== null)
            props.setApp(path, props.app);

        const userStorage = localStorage.getItem('userData')
        if (userStorage && userStorage !== 'undefined') {
            try {
                const user = JSON.parse(userStorage);
                if (user?.isAdmin)
                    props.setUserIsAdmin(path, true)
                else
                    props.setUserIsAdmin(path, false)

            } catch (e) {
                console.error(e);
            }
        }
    },[]);

    return <>
        {loading && showLoader()}
        { componentState && <AybCategoryList path={path} /> }
    </>
}

const mapStateToProps = _ => ({ })
const mapActionsToProps = ({
    ADD_STATE,
    REMOVE_STATE,
    setApp,
    setCategory,
    setUserIsAdmin
})

export default connect(mapStateToProps, mapActionsToProps)(XpaCategory)
